import { createAction } from '@reduxjs/toolkit';
import { withPayloadType } from '../../utils/withPayloadType';
import { monitors } from '../reducer/monitors';
import { ProtectedMonitorDetailsResponse } from '@um/uptime-monitoring-shared';

const initialize = createAction('monitors/initialize', withPayloadType<string>());
const onMonitorCreated = createAction('monitors/onMonitorCreated', withPayloadType<ProtectedMonitorDetailsResponse>());

const monitorsActions = { ...monitors.actions, initialize, onMonitorCreated };

export default monitorsActions;
